import { toast } from "react-toastify";

export const copyToClipboard = (text: string, message: string) => {
    if (text) {
        navigator.clipboard.writeText(text);
        toast.success(message);
    }
}